import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { Integration, IntegrationServices } from '@/modules/common/types/integrations';

import { IntegrationsRow } from './integrations-row';

interface IntegrationsTableProps {
  integrations: Integration[];
  onReasons: (service: IntegrationServices) => void;
  onConnect: (service: IntegrationServices) => void;
}

export const IntegrationsTable: FC<IntegrationsTableProps> = ({
  integrations,
  onReasons,
  onConnect,
}) => {
  const { t } = useTranslation(['authenticated.onboarding.integrations']);

  const columns = [
    t('integrationSection.table.integration'),
    t('integrationSection.table.type'),
    t('integrationSection.table.action'),
  ];

  return (
    <table className="w-full">
      <thead className="text-left text-sm text-muted-foreground">
        <tr className="border-b border-input">
          {columns.map((item, index) => (
            <th
              key={item}
              scope="col"
              className={cn(
                'font-medium py-3.5 px-4',
                index === columns.length - 1 && 'text-right'
              )}
            >
              {item}
            </th>
          ))}
        </tr>
      </thead>

      <tbody className="text-sm">
        {integrations.map((integration: Integration) => (
          <IntegrationsRow
            key={integration.service}
            integration={integration}
            onReasons={onReasons}
            onConnect={onConnect}
          />
        ))}
      </tbody>
    </table>
  );
};
